module.exports = __webpack_public_path__ + "img/cl.c48b0df1.svg";